import {
  jb_listing_item_css_default
} from "./chunk.4BSYC4XS.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  Linkable,
  getLinkIconName
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Filterable
} from "./chunk.P44ZUERG.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-listing-item/jb-listing-item.ts
var JbListingItem = class extends Filterable(Linkable(i)) {
  updated(changedProperties) {
    super.updated(changedProperties);
    if (!changedProperties.has("link") && !changedProperties.has("type")) {
      return;
    }
    const target = this.link?.target || this.link?.data?.type === "external" ? "_blank" : void 0;
    const download = !this.link?.target && this.link?.data?.type === "download";
    if (!this.link || target === this.link.target && download === this.link.download) {
      return;
    }
    this.link = { ...this.link, download, target };
  }
  render() {
    return b`
      <div class="list-item animate ${e({ "icon-first": this.iconFirst })}">
        <a data-linkable>
          <span class="text">
            ${this.text} ${this.file && b`| <span class="filetype">${this.file.type}</span>, ${this.file.size}`}
          </span>
          <div class="icon">
            <jb-icon
              .iconName=${getLinkIconName(this.link?.data?.type)}
              .ariaLabels=${{ label: this.link?.data?.ariaLabels?.iconLabel }}
            ></jb-icon>
          </div>
          ${this.date && b`<span class="second-line">${this.date}</span>`}
        </a>
      </div>
    `;
  }
};
JbListingItem.styles = [reset_css_default, jb_listing_item_css_default];
__decorateClass([
  n()
], JbListingItem.prototype, "date", 2);
__decorateClass([
  n({ type: Object })
], JbListingItem.prototype, "file", 2);
__decorateClass([
  n({ type: Boolean })
], JbListingItem.prototype, "iconFirst", 2);
__decorateClass([
  n()
], JbListingItem.prototype, "text", 2);
JbListingItem = __decorateClass([
  customElement("jb-listing-item")
], JbListingItem);

export {
  JbListingItem
};
